module.exports = __webpack_public_path__ + "img/DOMICIALIZ-LOGO.4276bd3b.png";